<cx-global-message aria-atomic="true" aria-live="assertive" style="width: auto"
  [isInnerHtmlEnable]="true"></cx-global-message>
<div class="address-book-page">
  <div class="address-book-title-box">
    <h1 class="address-book-title">{{"addressbook.pagetitle" | cxTranslate}}</h1>
  </div>
  <div class="address-book-section">
    <div class="address-book-section-title-box">
      <h2 class="address-book-section-title">{{"addressbook.heading" | cxTranslate}}</h2>
    </div>
    <div class="address-book-section-wrapper" *ngIf="addressObj">
      <div class="address-book-section-card" *ngFor="let address of addressObj">
        <div class="address-book-section-default-address-title" *ngIf="address.defaultAddress">
          {{"addressbook.defaultaddress" | cxTranslate}}
        </div>
        <div class="address-book-section-card-inner">
          <div class="address-book-section-line" *ngIf="address.firstName || address.lastName">{{address.firstName}}
            {{address.lastName}}</div>
          <div class="address-book-section-line" *ngIf="address.companyName">{{address.companyName}}</div>
          <div class="address-book-section-line" *ngIf="address.companyName">{{ (addressId$ | async).orgUnit?.uid}}
          </div>
          <div class="address-book-section-line" *ngIf="address.line1">{{address.line1}}</div>
          <div class="address-book-section-line" *ngIf="address.town">{{address.town}}</div>
          <div class="address-book-section-line" *ngIf="address?.region?.name">{{address?.region?.name}}</div>
          <div class="address-book-section-line" *ngIf="address?.country?.name">{{address?.country?.name}}</div>
          <div class="address-book-section-setdefault-address" *ngIf="!address.defaultAddress">
            <a href="javascript:void[0]" (click)="setAsDefault(address.id)"
              class="address-book-section-set-default-link">
              {{"addressbook.setdefault" | cxTranslate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>